import styled from '@emotion/styled';
import { Card } from 'antd';

export const Wrapper = styled(Card)`
  border-radius: 10px;
  height: 100%;
  overflow: hidden;

  .image-mask {
    border-radius: 8px;
  }
`;
